export const styledTicket = {
    '& + div': {marginLeft: '$sidebarQueueingTimeMarginHorizontal'},
    '& span': {
        fontSize: '$sidebarTicketText',
        fontWeight: '$sidebarTicketText',
        marginLeft: '$sidebarTicketTextMarginHorizontal',
    },
    'alignItems': 'center',
    'color': '$highlight',
    'display': 'flex',
    'marginLeft': '$sidebarTicketMarginHorizontal',
}
